module.exports = __webpack_public_path__ + "img/cases_mkdh.5d348a2d.jpg";